import { useMemo } from 'react';
import { FEATURE_GATED_ERROR } from '@pdqdev/pdq-shared/dist/utils/features-manifest';
import axios, { AxiosInstance } from 'react-axios';
import { useAuth } from '@app/react-common/auth/AuthContext';
import { getExtensionsApiUrl } from '@app/pages/checkout-app/utils/api.utils';

const BASE_URL = getExtensionsApiUrl();

export const useExtensionsApi = (errorCallback?: (data: any, status: number) => void): AxiosInstance => {
  const { authToken } = useAuth();

  const extensionsApi = useMemo<AxiosInstance>(() => {
    const instance = axios.create({
      baseURL: BASE_URL,
      headers: {
        Authorization: `Bearer ${authToken}`,
        'Content-Type': 'application/json',
      },
    });
    instance.interceptors.response.use(
      (response) => {
        return response;
      },
      (error) => {
        if (error.response) {
          const { data, status } = error.response;
          const isFeatureGated = status === 403 && data?.error === FEATURE_GATED_ERROR;
          if (!isFeatureGated && errorCallback) {
            console.error('Extensions API response error:', data, status);
            errorCallback(data, status);
          }
        }
        return Promise.reject(error);
      },
    );
    return instance;
  }, [authToken, BASE_URL]);

  return extensionsApi;
};
